import { IRoleDetail } from 'reducers/auth/model';
import { LoginDataType } from '../types/authType';
import ApiClient from './ApiClient';
import axios from 'axios';

export const loginApi = async (params: {
  email: string;
  phone: string;
  userAcc: string;
  gggToken: string;
}): Promise<LoginDataType | null> => {
  try {
    const { data } = await ApiClient.postJsonData('/Authentication/login', {}, params);
    return data;
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const getAuthorization = async (userId: string): Promise<IRoleDetail[] | null> => {
  try {
    const { data } = await ApiClient.get('/Users/getFunctionByUserID', { userId: userId }, {});
    return data;
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const redeemToken = async (params: any, token?: string): Promise<IRoleDetail[] | null> => {
  try {
    const { data } = await axios.post(
      process.env.REACT_APP_API_AUTHORITY + '/api/broker/redeem-code',
      params,
      {
        headers: {
          Authorization: 'Bearer ' + token || '',
        },
      }
    );
    return data;
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const getProfile = async (token?: string): Promise<IRoleDetail[] | null> => {
  try {
    const { data } = await axios.get(process.env.REACT_APP_API_AUTHORITY + '/connect/userinfo', {
      headers: {
        Authorization: 'Bearer ' + token || '',
      },
    });
    return data;
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const getClientToken = async (body: any): Promise<IRoleDetail[] | null> => {
  try {
    const formBody = new URLSearchParams();
    Object.entries(body || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formBody.append(key, String(value));
      }
    });

    const { data } = await axios.post(
      process.env.REACT_APP_API_AUTHORITY + '/connect/token',
      formBody,
      {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      }
    );
    return data;
  } catch (error: any) {
    return Promise.reject(error);
  }
};
